import { ModelDTO } from '../api/useModelGroupsQuery';

export const validateRiskRanges = (models: ModelDTO[]) => {
  if (models[0].riskRange.from !== 1 || models[models.length - 1].riskRange.to !== 100) {
    return false;
  }

  if (models.some(model => model.riskRange.to < model.riskRange.from)) {
    return false;
  }

  for (let i = 1; i < models.length; i += 1) {
    if (models[i - 1].riskRange.to + 1 !== models[i].riskRange.from) {
      return false;
    }
  }

  return true;
};
